import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Text from 'shopper/components/Text';

const BlackFridayGlossaryLetterItem = ({
  children,
  disabled = false,
  isSelected = false,
  onClick,
}) => (
  <button
    className={twJoin(
      'relative flex h-8 w-7 items-center justify-center gap-y-2 before:absolute before:bottom-0 before:w-full before:content-empty lg:w-8',
      isSelected
        ? 'before:h-[3px] before:bg-primary-300'
        : 'before:h-px before:bg-neutral-high-500',
      disabled && 'cursor-not-allowed'
    )}
    disabled={disabled}
    onClick={onClick}
  >
    <Text
      as="span"
      className="m-2 text-neutral-low-500 dark:text-neutral-high-100"
      bold
    >
      {children}
    </Text>
  </button>
);

BlackFridayGlossaryLetterItem.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default BlackFridayGlossaryLetterItem;
